import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as globalAdd from '../../connectionString';
import { CreateLinkPaypalPlanModal } from '../../modules/Paypal/models/CreateLinkPaypalPlan.model';
import { PaypalLinkPaymentModal } from '../../modules/Paypal/models/PaypalLinkPayment.model';


@Injectable()
export class IpsPaymentViaLinkServiceService {

  constructor(private http: HttpClient) { }
  ipsPaymentLinkCheck(linkCode) {
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
     return this.http.get(globalAdd.Paneladdress + 'api/IPS/BuyProduct/ipsPaymentLinkCheck?linkCode='+linkCode, { headers: Headers });
   }

   paypalLinkPayment(modal:PaypalLinkPaymentModal) {
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
     return this.http.post(globalAdd.Paneladdress + 'api/IPS/BuyProduct/paypalLinkPayment',modal, { headers: Headers });
   }

   createLinkProductAndPlanForNewHa(hospitalName:string,saName:string,trialValue:number,fixedValue:number){
     let PlanModal:CreateLinkPaypalPlanModal = new CreateLinkPaypalPlanModal(hospitalName,saName,trialValue,fixedValue);
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
     return this.http.post(globalAdd.Paneladdress + 'api/SendLink/BuyProduct/createPaypalPlanLinkHa',PlanModal, { headers: Headers });
   }
}
